<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSecurityGroupListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableSecurityGroupVue = {};
export default {
  name: "TableRi",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("permission_configuration_management.account.accountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t("RAM.AWS.DMS.name"),
          key: "replicationInstanceIdentifier"
        },
        {
          title: this.$t("RAM.AWS.KMS.status"),
          key: "status"
        },
        {
          title: 'VPC',
          key: "vpcId"
        },
        {
          title: this.$t("RAM.AWS.DMS.class"),
          key: "replicationInstanceClass"
        },
        {
          title: this.$t("RAM.AWS.DMS.engineVersion"),
          key: 'engineVersion'
        },
        {
          title: this.$t("RAM.AWS.DMS.availabilityZone"),
          key: 'availabilityZone'
        },
        {
          title: this.$t("RAM.AWS.DMS.publicIPAddress"),
          key: 'replicationInstancePublicIpAddress'
        },
        {
          title: this.$t("RAM.AWS.DMS.privateIPAddress"),
          key: 'replicationInstancePrivateIpAddress'
        },
        {
          title: this.$t("RAM.AWS.DMS.multiAZ"),
          key: 'multiAzString'
        },
        {
          title: this.$t("RAM.AWS.DMS.created"),
          key: 'instanceCreateTime'
        },
        {
          title: 'ARN',
          key: 'replicationInstanceArn'
        }
      ],
      tableSecurityGroupListData: []
    };
  },
  beforeCreate: function() {
    tableSecurityGroupVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableSecurityGroupVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSecurityGroupVue.companyId = val;
    });
    eventBus.$on("name", function(val) {
      tableSecurityGroupVue.name = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 分页显示数据
    /****************************************************/
    getSecurityGroupListData: function() {
      var pageSecurityGroupDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        accountName: tableSecurityGroupVue.accountName,
        companyId: tableSecurityGroupVue.companyId,
        replicationInstanceIdentifier: tableSecurityGroupVue.name
      };
      this.$api.cmdb
        .pagingQueryAwsDmsInstanceReplication(pageSecurityGroupDate)
        .then(res => {
          this.tableSecurityGroupListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    beforeDestroy: function() {
      eventBus.$off("accountName");
      eventBus.$off("companyId");
      eventBus.$off("name");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/dms/replicationInstances/TableRI.vue